














































































































import { Component, Vue } from 'vue-property-decorator'
import MainTemplate from '@/components/MainTemplate.vue'
import { getCMSResourceById, getDownloadUrl, getSourceInfo, getCouponCount } from './models/api'
import categories, { fileTypes } from './config/categories'
import { sa } from '@/utils/sa'

@Component({
  components: {
    MainTemplate
  }
})
export default class SourcePreview extends Vue {
  private file: any = {
    id: '',
    name: '', // 名称
    type: '', // 文件格式
    created: '', // 创建时间
    updated: '', // 更新时间
    preview: '', // 在线预览地址
    price: 0, // 素材价格
    hasDonwloaded: false // 素材是否被当前用户下载过
  }
  private couponNum: number = 0 // 当前用户拥有的下载券数目
  private isDownloadModalVisible: boolean = false
  private confirmLoading: boolean = false

  private async mounted() {
    this.file.id = this.$route.query._id || ''
    this.renderSourceDetails()
    this.renderSourceInfo()
    this.renderUserCouponInfo()
  }
  // 填充素材基础信息
  private async renderSourceDetails() {
    const options = { cms_resource_id: this.file.id }
    const res = await getCMSResourceById(options)

    if (res.success) {
      const {
        msg: { filename, preview_urls, url, created_at: createdAt, updated_at: updatedAt }
      } = res
      const type = filename.substring(filename.lastIndexOf('.') + 1).toLowerCase()
      const previewList = preview_urls.map((item) => {
        return {
          url: item,
          type: this.judge(item)
        }
      })
      this.file = Object.assign({}, this.file, {
        name: filename,
        type,
        preview: url,
        created: createdAt,
        updated: updatedAt,
        previewList
      })

      // this.renders(type, url)
    }
  }
  // 填充素材价格信息
  private async renderSourceInfo() {
    const options = { cms_resource_id: this.file.id }
    const res = await getSourceInfo(options)

    if (res.success) {
      const {
        msg: { has_downloaded: hasDonwloaded, price }
      } = res

      this.file = Object.assign({}, this.file, {
        hasDonwloaded,
        price
      })
    }
  }
  // 填充用户账户信息
  private async renderUserCouponInfo() {
    const res = await getCouponCount({})

    if (res.success) {
      this.couponNum = res.coupon_num
    }
  }
  // 获取素材下载地址
  private async getDownload() {
    const options = { cms_resource_id: this.file.id }
    const res = await getDownloadUrl(options)
    let download: string = ''

    if (res.success) {
      const {
        msg: { download_url }
      } = res
      // 埋点
      sa.track('ContentRepository_question_Download', {
        action: '下载成功',
        modules: this.$route.meta.modules
      })
      download = download_url
    }

    return download
  }
  // 下载
  private async downloadFile() {
    await this.renderSourceInfo() // 防止用户第一次下载后，立刻再次点击下载

    if (this.file.hasDonwloaded) {
      // 埋点
      sa.track('ContentRepository_question_Download', {
        action: '点击下载',
        modules: this.$route.meta.modules
      })
      // 下载过，直接获取下载地址，下载
      const download: string = await this.getDownload()
      window.open(download)
    } else {
      // 没下载过，打开下载框
      // 埋点
      sa.track('ContentRepository_question_Download', {
        action: '弹窗',
        modules: this.$route.meta.modules
      })
      this.isDownloadModalVisible = true
    }
  }
  private async handleDownloadOk(e) {
    // 埋点
    sa.track('ContentRepository_question_Download', {
      action: '点击下载',
      modules: this.$route.meta.modules
    })
    if (this.couponNum >= this.file.price) {
      this.confirmLoading = true
      const download: string = await this.getDownload()
      this.confirmLoading = false
      this.isDownloadModalVisible = false
      window.open(download)
    } else {
      this.$message.info('没有下载券哦，请去购买~')
    }
  }
  private handleDownloadCancel(e) {
    this.isDownloadModalVisible = false
  }
  private category: number = 0 // 素材类别
  public judge(url) {
    const type = url.substring(url.lastIndexOf('.') + 1).toLowerCase()
    const { value } = categories.filter((item) => item.children.includes(type))[0]
    return value
  }
  public async renders(type, url) {
    const { value } = categories.filter((item) => item.children.includes(type))[0]

    switch (value) {
      case fileTypes.office: // office 文件
        this.category = fileTypes.office
        break
      case fileTypes.video: // 视频
        this.category = fileTypes.video
        break
      case fileTypes.audio: // 音频
        this.category = fileTypes.audio
        break
      case fileTypes.pdf: // pdf
        this.category = fileTypes.pdf
        break
      case fileTypes.zip: // 压缩文件
        this.category = fileTypes.zip
        break
      default:
        // 未知文件类型
        this.category = fileTypes.unknown
    }
  }
  public onChange(from, to) {
    console.log(from)
    console.log(to)
  }
  public showPayModal() {
    this.$store.commit('SET_PAYMODAL', { state: true, index: 0 })
  }
}
